module.exports = __webpack_public_path__ + "img/thumbnail_GrizzlyBear_f_normal.833db075.png";